<template>
    <NavMenu :menu="menu" />
</template>

<script setup>

import NavMenu from '../NavMenu.vue';

import {
  Menu,
  userHasPermission,
} from '@/internal';

import {computed} from "vue";

const menu = computed(() => {
  return new Menu({
    title: 'Create',
    menuItems: [
      {
        icon: 'file-plus',
        route: {
          name: 'forms/create',
        },
        title: 'Form',
        when: userHasPermission('form:create'),
        iconPack: 'fal',
      },
      {
        icon: 'file-plus',
        route: {
          name: 'questions/create',
        },
        title: 'Form Question',
        when: userHasPermission('formQuestion:create'),
        iconPack: 'fal',
      },
    ],
  });
});

</script>
